import { ChangeDetectionStrategy, Component, ErrorHandler, EventEmitter, Input, OnInit, Output, signal } from '@angular/core'

import { RaporttiType } from '@lemon/core-firebase/model/reports-shared'
import {
  Kirjanpitotili,
  RaporttiRequest,
  RaporttiVirallinenTaselaskelmaData,
  RaporttiVirallinenTaselaskelmaDataResponse,
  RaporttiVirallinenTaselaskelmarivi,
} from 'app/_jaettu-lemonator/model/kirjanpito'
import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs'
import { startWith, switchMap, tap } from 'rxjs/operators'
import { KlikattuKirjaus, RaporttienHakuvaihtoehdot } from '../raportit.component'

import { Timestamp } from '@lemon/core/model/common'
import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'

@Component({
  selector: '[app-kirjanpito-taselaskelma-virallinen]',
  templateUrl: './taselaskelma-virallinen.component.html',
  styleUrls: ['./taselaskelma-virallinen.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KirjanpitoRaportitTaselaskelmaVirallinenComponent implements OnInit {
  @Input() hakuvaihtoehdotObservable: Observable<RaporttienHakuvaihtoehdot>
  @Input() tilitMapObservable: Observable<Map<string, Kirjanpitotili>>
  @Input() paivitaArvotHiljaisestiSubject: BehaviorSubject<number>
  @Input() taseEnsin: boolean

  @Output() kirjaustaKlikattiin: EventEmitter<KlikattuKirjaus> = new EventEmitter()
  @Output() tulosEnsinClicked: EventEmitter<boolean> = new EventEmitter()

  readonly lastSucessfullyUpdated = signal<Timestamp>(undefined)

  readonly lataa = signal(true)
  tuloslaskelmanDataObservable: Observable<RaporttiVirallinenTaselaskelmaData>

  constructor(
    private _errorHandler: ErrorHandler,
    private _firebase: FirebaseLemonator,
    private _asiakasService: AsiakasService,
    private _timestampService: TimestampService,
  ) {}

  ngOnInit() {
    this.tuloslaskelmanDataObservable = combineLatest([
      this._asiakasService.nykyinenAsiakasObservable,
      this.hakuvaihtoehdotObservable.pipe(
        tap(() => {
          this.lataa.set(true)
        }),
      ),
      this.paivitaArvotHiljaisestiSubject,
    ]).pipe(
      switchMap(([asiakas, hakuvaihtoehdot, paivita]) => {
        if (!hakuvaihtoehdot?.alkaa || !hakuvaihtoehdot?.loppuu) {
          return of<RaporttiVirallinenTaselaskelmaData>(null)
        }

        const haku: RaporttiRequest = {
          a: asiakas.avain,
          k: 'fi',
          w: RaporttiType.TASE_VIRALLINEN,
          s: hakuvaihtoehdot.alkaa,
          e: hakuvaihtoehdot.loppuu,
          datasource: hakuvaihtoehdot.datasource,
        }
        // if (hakuvaihtoehdot.tilista) { haku.b = hakuvaihtoehdot.tilista }
        // if (hakuvaihtoehdot.tiliin) { haku.c = hakuvaihtoehdot.tiliin }
        // if (hakuvaihtoehdot.vapaasanahaku?.trim()) { haku.t = hakuvaihtoehdot.vapaasanahaku.trim() }
        if (hakuvaihtoehdot.projekti) {
          haku.p = hakuvaihtoehdot.projekti
        }

        return this._firebase
          .functionsCall<RaporttiRequest, RaporttiVirallinenTaselaskelmaDataResponse>('kirjanpitoRaportitData', haku)
          .then(res => {
            if (res.e) {
              throw new Error(res.e)
            }
            this.lastSucessfullyUpdated.set(this._timestampService.now())
            this.lataa.set(false)
            return res.data
          })
          .catch(err => {
            console.error('Failed to fetch report data', err)
            this._errorHandler.handleError(err)
          })
      }),
      startWith<RaporttiVirallinenTaselaskelmaData>({
        c1Header: null,
        c2Header: null,
        c: null,
        data: [],
      }),
    )
  }

  focusOnKirjaus(kirjausnumero: string) {
    this.kirjaustaKlikattiin.emit({ kirjausnumero: kirjausnumero })
  }

  trackAccountRowByAccountNumberFn(index: number, item: RaporttiVirallinenTaselaskelmarivi) {
    return index
  }
}
